<div class="toaster-notification w-full border-solid border-2 rounded-xl shadow-xl bg-white overflow-hidden
      border-{{notificationType}}">
  <div class="w-full h-1 bg-timer-{{notificationType}}">
    <div class="h-full timer-bar rounded-xl"
         [style.width.%]="timerProgress"
         [style.transition]="timerTransition">
    </div>
  </div>
  <div class="grid grid-cols-12 w-full h-full p-[1rem] border-{{notificationType}}">

    <div class="col-span-2 float-left">
      <div class="rounded-2xl bg-icon-{{notificationType}} h-[2.5rem] w-[2.5rem] p-[0.75rem]">
        @switch (notificationType) {
          @case (ToasterNotificationType.INFORMATION) {
            <img src="./assets/icons/info-circle.svg" alt="Info Icon" class="w-full h-full" />
          }
          @case (ToasterNotificationType.SUCCESS) {
            <img src="./assets/icons/tick-circle.svg" alt="Success Icon" class="w-full h-full" />
          }
          @case (ToasterNotificationType.WARNING) {
            <img src="./assets/icons/danger.svg" alt="Warning Icon" class="w-full h-full" />
          }
          @case (ToasterNotificationType.ERROR) {
            <img src="./assets/icons/close-circle.svg" alt="Error Icon" class="w-full h-full" />
          }
        }
      </div>
    </div>

    <div class="col-span-8">
      <h3 class="notification-title font-bold text-color-{{notificationType}}">{{notificationTitle}}</h3>
      <p class="notification-message text-sm">{{notificationMessage}}</p>
    </div>

    <div class="col-span-2 w-full h-full">
      <button
          class="notification-close-btn float-right w-fit h-fit"
          (click)="onCloseNotificationClick()">
        <img src="./assets/icons/close.svg" alt="Close Icon" class="h-[1.2rem] w-[1.2rem]" />
      </button>
    </div>
  </div>
</div>